import React from "react";
import { Github, Mail, ArrowUpRight, Code, FileText, User, Send } from "lucide-react";
import { Link } from "react-router-dom";

const CHANNELS = [
  { label: "GitHub", href: "https://github.com/Maverick-list", icon: Github, external: true, desc: "@Maverick-list" },
  { label: "Email", href: "mailto:firzailmidja@gmail.com", icon: Mail, external: true, desc: "firzailmidja@gmail.com" },
  { label: "Selected Works", href: "/works", icon: Code, external: false, desc: "Production systems & RAG" },
  { label: "Field Notes", href: "/articles", icon: FileText, external: false, desc: "Design tokens & informatics" },
  { label: "Bio & Path", href: "/about", icon: User, external: false, desc: "Background & education" },
  { label: "Direct Inquiries", href: "/contact", icon: Send, external: false, desc: "Availability & scope" },
];

export default function Footer() {
  return (
    <footer className="relative mt-28 border-t border-border/60 pb-12 pt-16 px-6 sm:px-8 lg:px-12 bg-card/20">
      <div className="max-w-[1360px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 pb-14 border-b border-border/50">
          
          <div className="lg:col-span-5 space-y-4">
            <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-primary font-medium block">
              fmi.dev · Direct Contact
            </span>
            <h3 className="text-3xl sm:text-4xl font-medium tracking-display text-foreground leading-tight">
              Engineering serious software at the intersection of systems and applied AI.
            </h3>
            <p className="text-foreground/75 text-[15px] leading-relaxed max-w-[45ch]">
              Based in Indonesia (GMT+7). Available for select full-stack architecture contracts, RAG pipeline engineering, and informatics research.
            </p>
            <div className="pt-2">
              <a
                href="mailto:firzailmidja@gmail.com"
                className="inline-flex items-center gap-2 font-mono text-[12px] tracking-[0.16em] uppercase text-primary hover:underline"
              >
                firzailmidja@gmail.com <ArrowUpRight className="h-3.5 w-3.5" />
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="font-mono text-[11px] tracking-[0.22em] uppercase text-muted-foreground block mb-4">
              Verified Navigation & Channels
            </span>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {CHANNELS.map((item) => {
                const Icon = item.icon;
                if (item.external) {
                  return (
                    <a
                      key={item.label}
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="p-4 rounded-xl border border-border/70 bg-card/40 hover:bg-secondary/40 hover:border-primary/50 transition-colors group flex flex-col justify-between"
                    >
                      <div className="flex items-center justify-between mb-2">
                        <Icon className="h-4 w-4 text-primary" />
                        <ArrowUpRight className="h-3 w-3 text-muted-foreground group-hover:text-primary transition-colors" />
                      </div>
                      <div>
                        <span className="font-mono text-[11px] tracking-wider uppercase text-foreground font-medium block">
                          {item.label}
                        </span>
                        <span className="font-mono text-[10px] text-muted-foreground truncate block mt-0.5">
                          {item.desc}
                        </span>
                      </div>
                    </a>
                  );
                }
                return (
                  <Link
                    key={item.label}
                    to={item.href}
                    className="p-4 rounded-xl border border-border/70 bg-card/40 hover:bg-secondary/40 hover:border-primary/50 transition-colors group flex flex-col justify-between"
                  >
                    <div className="flex items-center justify-between mb-2">
                      <Icon className="h-4 w-4 text-primary" />
                      <ArrowUpRight className="h-3 w-3 text-muted-foreground group-hover:text-primary transition-colors" />
                    </div>
                    <div>
                      <span className="font-mono text-[11px] tracking-wider uppercase text-foreground font-medium block">
                        {item.label}
                      </span>
                      <span className="font-mono text-[10px] text-muted-foreground truncate block mt-0.5">
                        {item.desc}
                      </span>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>

        </div>

        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 font-mono text-[11px] tracking-[0.16em] uppercase text-muted-foreground">
          <span>&copy; {new Date().getFullYear()} Firza Miftahul Ilmi &middot; All Rights Reserved</span>
          <span>Informatics &middot; Applied AI &middot; TypeScript</span>
        </div>
      </div>
    </footer>
  );
}
